@for (usageType of usageTypes$ | async; track usageType.technicalName) {
  @if (usageType.technicalName === 'EU-Access') {
    @if (transactionTypeTexts$ | async; as transactionTypeTexts) {
      <div class="w-100 separator mt-4 mb-5"></div>
      <div class="row mt-5">
        <div class="col-12 col-sm-4 col-lg-4">
          <h3 class="m-0 mb-4 d-flex flex-column justify-content-center min-input-height--sm text-blue-gray body--s">
            {{ transactionTypeTexts.euAccess }}
          </h3>
        </div>
        <div class="col-12 col-sm-8 col-lg-8 m-0 mb-4 d-flex justify-content-start align-items-center">
          <udex-switch
            [attr.checked]="formControl.value || null"
            (change)="formControl.setValue($event.target['checked'])">
          </udex-switch>
          <dcp-icon-button-tooltip
            [openOnClick]="true"
            placement="End"
            [attr.accessible-name]="'configurator.euAccessTooltip' | cxTranslate"
            [attr.aria-label]="'configurator.euAccessTooltip' | cxTranslate">
            <span class="body--s">{{ 'configurator.euAccessTooltip' | cxTranslate }}</span>
          </dcp-icon-button-tooltip>
        </div>
      </div>
    }
  }
}
